import React from 'react';
import { Check } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function ProductSection() {
  return <section className="w-full bg-white py-10 px-4" data-id="element-131">
      <div className="max-w-4xl mx-auto" data-id="element-132">
        <div className="text-center mb-8" data-id="element-133">
          <p className="text-xl font-bold text-gray-500 uppercase tracking-wider mb-2" data-id="element-134">
            Te presentamos el
          </p>
          <h2 className="text-4xl md:text-5xl font-black uppercase text-[#DEA0C0]" data-id="element-135">
            KIT APRENDIZAJE EN CASA
          </h2>
        </div>

        <div className="border-4 border-blue-100 rounded-3xl p-8 md:p-12 shadow-lg bg-[#F9FAFB]" data-id="element-136">
          <p className="text-xl md:text-2xl font-bold text-gray-900 mb-8 text-center" data-id="element-137">
            Un material práctico basado en herramientas psicopedagógicas que te
            ayudará a:
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-138">
            {['Comprender cómo aprende tu hijo', 'Acompañarlo sin generar frustración', 'Estimular su interés por aprender', 'Mejorar la concentración y la comprensión', 'Transformar el aprendizaje en una experiencia positiva'].map((item, index) => <div key={index} className="flex items-start bg-white p-4 rounded-xl shadow-sm border border-blue-50" data-id="element-139">
                <div className="bg-green-100 rounded-full p-1 mr-4 flex-shrink-0 mt-1" data-id="element-140">
                  <Check className="h-6 w-6 text-green-600 stroke-[3]" data-id="element-141" />
                </div>
                <span className="text-lg font-semibold text-gray-800" data-id="element-142">
                  {item}
                </span>
              </div>)}
          </div>

          <div className="text-center mt-10" data-id="element-143">
            <p className="inline-block px-6 py-3 rounded-full text-xl font-bold text-[#DEA0C0] bg-[#F9FAFB]" data-id="element-144">
              Todo explicado de forma simple y pensado especialmente para
              padres.
            </p>
          </div>

          <div className="flex justify-center mt-10" data-id="element-145">
            <CTAButton text="¡QUIERO EL KIT AHORA!" subtext="Acceso inmediato · Descarga digital" data-id="element-146" />
          </div>
        </div>
      </div>
    </section>;
}